export default __webpack_public_path__ + "static/media/icon-logbook.68c67803.svg";